import {
  Box,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { useAnimation } from "../contexts/AnimationContext";
import Drivers from "./Drivers";
import Taxis from "./Taxis";
import Uber from "./Uber";

function Travel() {
  const textRef = useRef(null);
  const { animationStarted } = useAnimation();
  const textInView = useInView(textRef, { once: true, margin: "0px" });

  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
  const isMedium = useMediaQuery(theme.breakpoints.only("md"));

  return (
    <>
      <Container maxWidth="md" sx={{ mt: 3, mb: 0 }}>
        <Box
          component={motion.div}
          ref={textRef}
          initial={{ opacity: 0, y: 30 }}
          animate={
            textInView && animationStarted
              ? { opacity: 1, y: 0 }
              : { opacity: 0, y: 30 }
          }
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          sx={{
            textAlign: "justify",
            px: { xs: 2, sm: 4, md: 6 },
            mb: 0,
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: "1rem", sm: "1.1rem" },
              lineHeight: 2,
              color: "#2d4e66",
              mb: 4,
            }}
          >
            A Igreja de São Quintino e a Quinta de D. Carlos têm parque de
            estacionamento. De todo o modo, deixamos-vos também informações
            relativas aos serviços de transportes de e para Alenquer, se
            preferirem não conduzir.
          </Typography>
        </Box>
      </Container>

      {isLarge && (
        <Container maxWidth="lg" sx={{ mt: -4, mb: 0 }}>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              px: { xs: 2, sm: 4, md: 6 },
            }}
          >
            <Box sx={{ flex: "0 0 28%" }}>
              <Taxis />
            </Box>

            <Box sx={{ flex: "0 0 40%" }}>
              <Uber />
            </Box>

            <Box sx={{ flex: "0 0 32%" }}>
              <Drivers />
            </Box>
          </Box>
        </Container>
      )}

      {isMedium && (
        <Container maxWidth="md" sx={{ mt: -4, mb: 0 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              columnGap: 12,
            }}
          >
            <Box sx={{ flex: "0 0 auto" }}>
              <Taxis />
            </Box>

            <Box sx={{ flex: "0 0 auto" }}>
              <Drivers />
            </Box>
          </Box>

          <Container maxWidth="md">
            <Uber />
          </Container>
        </Container>
      )}

      {!isLarge && !isMedium && (
        <>
          <Container maxWidth="md" sx={{ mt: -3, mb: 0 }}>
            <Container maxWidth="md">
              <Taxis />
              <Drivers />
            </Container>
            <Uber />
          </Container>
        </>
      )}
    </>
  );
}

export default Travel;
